import HttpService from './HttpService';

export default class BusinessService extends HttpService {
    endPoint = "/v1/business"
}
